import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dropzone/styles.css';

import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './lib/queryClient';
import { router } from './router';
import { theme } from './styles/theme';
import { PostHogProvider } from './lib/posthog';
import { StatsigWrapper } from './lib/statsig';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PostHogProvider>
        <StatsigWrapper>
          <MantineProvider theme={theme}>
            <ModalsProvider>
              <Notifications position="top-right" />
              <RouterProvider router={router} />
            </ModalsProvider>
          </MantineProvider>
        </StatsigWrapper>
      </PostHogProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
